import { FC } from 'react';
import { MailIcon, PayoutsIcon, PhoneIcon2 } from 'assets/icons';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { CustomAvatar } from 'components';
import { getInitials } from 'utils/commonUtils';
import { getMemberPayRunStatusMap } from '../utils';
interface MemberReviewSummaryProps {
  jobDetails: {
    needsReviewJobs: number;
    skippedJobs: number;
    inProgressJobs: number;
    confirmedJobs: number;
  };
  totalAmount: string;
  totalAdjustmentAmount: string;
  merchantDetails: {
    profilePictureURL: string;
    name: string;
    phone: string;
    email: string;
  };
  status: string;
  grossPayAmount: string;
  jobAdjustmentAmount: string;
  otherAdjustmentAmount: string;
}

const MemberReviewSummaryCard: FC<MemberReviewSummaryProps> = ({
  jobDetails,
  totalAmount,
  grossPayAmount,
  otherAdjustmentAmount,
  merchantDetails,
  status
}) => {
  return (
    <>
      {/* Member Info Section */}
      <div
        id="member-review-summary-card"
        className="flex justify-between gap-4 border-b border-borderGray bg-[#AAD1F91A] py-3 px-[30px]">
        <div className="flex items-start gap-4 py-7">
          <CustomAvatar
            src={merchantDetails?.profilePictureURL}
            label={getInitials(merchantDetails?.name)}
            className="h-[93px] w-[93px] rounded-full"
          />
          <div className="flex flex-col gap-3">
            <div className="text-2xl font-bold text-heading">{merchantDetails?.name}</div>
            <div className="flex gap-4 text-sbase font-semibold text-accentText">
              <div className="flex items-center gap-2">
                <PhoneIcon2 className="path path-fill-current h-4 w-4 text-accentText" />
                {merchantDetails?.phone ? merchantDetails?.phone : '-'}
              </div>
              {merchantDetails?.email && (
                <div className="flex items-center gap-2">
                  <MailIcon className="path path-fill-current h-4 w-4 text-accentText" />
                  {merchantDetails?.email}
                </div>
              )}
            </div>
            <div
              style={{
                backgroundColor: getMemberPayRunStatusMap(status).bg,
                color: getMemberPayRunStatusMap(status).text,
                borderColor: getMemberPayRunStatusMap(status).border
              }}
              className="inline-flex w-fit items-center gap-2 rounded-md border 
               px-3 py-1 text-sm capitalize">
              <span className="inline-block h-1 w-1 rounded-full bg-current" /> {getMemberPayRunStatusMap(status).label}
            </div>
          </div>
        </div>
        <div className="flex gap-6 rounded-xl border bg-white ">
          <div className="relative flex w-[325px] flex-col gap-2 overflow-hidden py-6 pl-4">
            <div className="paymentTileEllipse pointer-events-none absolute top-[-85px] right-[-60px]" />
            <div className="paymentTileEllipse pointer-events-none absolute top-[50px] right-[-70px]" />
            <div className="flex items-center gap-2">
              <PayoutsIcon className="path path-stroke-current h-4 w-4 text-secondaryBtnText" />
              <div className="text-sm font-semibold text-primaryBlue">Needs review</div>
            </div>
            <div className="text-2xl font-bold text-headingBlack">{jobDetails.needsReviewJobs} Jobs</div>
            <div className="flex flex-col gap-2 text-[13px] text-accentText">
              <div>{jobDetails.skippedJobs} Skipped</div>
              <div>{jobDetails.inProgressJobs} In progress</div>
              <div>{jobDetails.confirmedJobs} Confirmed</div>
            </div>
          </div>

          <div className="relative flex w-[325px] flex-col gap-2 overflow-hidden py-6 pr-4">
            <div className="paymentTileEllipse pointer-events-none absolute top-[-85px] right-[-60px]" />
            <div className="paymentTileEllipse pointer-events-none absolute top-[50px] right-[-70px]" />
            <div className="flex items-center gap-2">
              <PayoutsIcon className="path path-stroke-current h-4 w-4 text-secondaryBtnText" />
              <div className="text-sm font-semibold text-primaryBlue">Total balance</div>
            </div>
            <div className="text-2xl font-bold text-headingBlack">{getAmountWithCurrency(totalAmount)}</div>
            <div className="flex flex-col gap-2 text-[13px] text-accentText">
              <div>{getAmountWithCurrency(grossPayAmount)} Gross pay from confirmed jobs</div>
              <div>{getAmountWithCurrency(otherAdjustmentAmount)} Other adjustments</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberReviewSummaryCard;
